import { render, staticRenderFns } from "./poste-soins-unites.vue?vue&type=template&id=f1db80a8&scoped=true"
import script from "./poste-soins-unites.vue?vue&type=script&lang=js"
export * from "./poste-soins-unites.vue?vue&type=script&lang=js"
import style0 from "./poste-soins-unites.vue?vue&type=style&index=0&id=f1db80a8&prod&scoped=true&lang=css"
import style1 from "./poste-soins-unites.vue?vue&type=style&index=1&id=f1db80a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1db80a8",
  null
  
)

export default component.exports